(ns practitest.frontend.xbot.agents-view.av-availability-status
  (:require
    [practitest.frontend.common.ui :as ui]
    [practitest.frontend.xbot.agents-view.av-common :as av-common]))

(defn agent-log-output [std-out-err]
  [:div.agent-output
   (into [:ul.std-out-err {:style {:overflow-y (if (nil? std-out-err) "hidden" "scroll")}}]
         (for [{:keys [timestamp text]} std-out-err]
           [:li (.format (js/moment timestamp) "YYYY-MM-DD hh:mm:ss") ": " text]))])

(defn agent-log-title [title]
  [:p.bold
   {:style {:margin-bottom "0px"}}
   title])

(defn agent-log-std-out-err [title std-out-err]
  [:<>
   [agent-log-title title]
   [agent-log-output std-out-err]])

(defn agent-log-last-output-title []
  [:span.bold
   {:style {:margin-top    "10px"
            :margin-bottom "10px"}}
   "Last Output:"])

(defn display-agent-log [{:keys [stderr stdout]}]
  [:<>
   [agent-log-last-output-title]
   [agent-log-std-out-err "STDERR" stderr]
   [agent-log-std-out-err "STDOUT" stdout]])

(defn availability-status-icon [title icon-class color]
  [:span
   {:style {:color         color
            :margin-bottom "10px"
            :margin-left   "-5px"}}
   [ui/icon icon-class]
   [:span title]])

(defn availability-status-show-agent-log [state]
  [ui/eye-show-hide state :show-log? "View agent's log"])

(defn display-availability-status [{:keys [busy? online?] :as agent} state]
  [:div.col-sm-12.col-md-6.col-lg-6.no-padding-sides
   [:div.top-text.col-sm-12.col-md-12.col-lg-12.agent-availability-status
    {:style {:padding-right "15px"
             :width         "100%"}}
    [:div
     {:style {:display         "flex"
              :justify-content "space-between"}}
     [av-common/agent-view-titles "Availability status: "]
     (when online?
       [availability-status-show-agent-log state])]
    (when online?
      [:div
       {:style {:display        :flex
                :flex-direction :column}}
       (if busy?
         [availability-status-icon "Busy" "fa-minus-square fa-fw" av-common/color-busy]
         [availability-status-icon "Free" "fa-dot-circle-o fa-fw" "green"])
       [av-common/display-underline]
       (when (or (:show-log? @state) (and busy? (nil? (:show-log? @state))))
         [display-agent-log agent state])])]])
